import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global fetch cache for hot endpoints to prevent 429s
(() => {
  try {
    const originalFetch = window.fetch.bind(window);
    const cache = new Map();
    const TTL_MS = 30000; // 30 seconds
    
    const shouldCache = (url, options) => {
      if (!url) return false;
      const u = typeof url === 'string' ? url : url.toString();
      const method = (options && options.method) ? options.method.toUpperCase() : 'GET';
      if (method !== 'GET') return false;
      
      // ✅ Cache these frequently-called endpoints
      return u.includes('/api/dashboard/leave-summary') || 
             u.includes('/api/leave-history/user-requests') ||
             u.includes('/api/user-leave-requests') ||
             u.includes('/api/employees/batch-leave-data') ||  // ✅ NEW: Cache batch endpoint
             u.includes('/api/employee-list');  // ✅ Also cache employee list
    };

    window.fetch = async (input, init = {}) => {
      const urlStr = typeof input === 'string' ? input : input.toString();
      if (!shouldCache(urlStr, init)) {
        return originalFetch(input, init);
      }

      const now = Date.now();
      const entry = cache.get(urlStr);
      
      // Return cached response if still valid
      if (entry && entry.responseBody && (now - entry.ts) < TTL_MS) {
        console.log('📦 Cache HIT:', urlStr);
        return new Response(entry.responseBody.slice(0), entry.responseInit);
      }
      
      // Return in-flight request if one exists
      if (entry && entry.inFlight) {
        console.log('⏳ Waiting for in-flight request:', urlStr);
        const res = await entry.inFlight;
        return res.clone();
      }

      // Make new request
      console.log('🌐 Cache MISS - fetching:', urlStr);
      const fetchPromise = originalFetch(input, init).then(async (res) => {
        const clone = res.clone();
        const buffer = await clone.arrayBuffer();
        const responseInit = { 
          status: res.status, 
          statusText: res.statusText, 
          headers: res.headers 
        };
        cache.set(urlStr, { 
          ts: Date.now(), 
          responseBody: buffer, 
          responseInit, 
          inFlight: null 
        });
        return new Response(buffer.slice(0), responseInit);
      }).catch((err) => {
        if (entry) entry.inFlight = null;
        throw err;
      });

      cache.set(urlStr, { 
        ts: now, 
        responseBody: null, 
        responseInit: null, 
        inFlight: fetchPromise 
      });
      
      const res = await fetchPromise;
      return res.clone();
    };
  } catch (_) {
    console.warn('⚠️ Fetch cache initialization failed');
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);